import { AgencyService } from './api/agency.service';
import { exportTranslateStaticLoader } from './i18n/translate-browser-loader.service';
/* tslint:disable:only-arrow-functions */
export function getWindow() {
    return (typeof window !== 'undefined') ? window : null;
}
export function getScreen() {
    return (typeof screen !== 'undefined') ? screen : null;
}
export function agencyProviderFactory(provider) {
    return function () { return provider.getAgency(); };
}
var ɵ0 = exportTranslateStaticLoader;
/* tslint:enable */
var CommonThemeModule = /** @class */ (function () {
    function CommonThemeModule() {
    }
    return CommonThemeModule;
}());
export { CommonThemeModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/common-theme/common-theme.module.ts.pre-build-optimizer.js